






















































































import _ from 'lodash'
import * as pbi from 'powerbi-client'
import EventBus from '@/plugins/EventBus'
import { api as fullscreen } from 'vue-fullscreen'
import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import { PowerBiReportType, Rede } from '@/types/_'
import Apis from '@/Apis/_'
import { getSnackbarMessage } from '@/utils/common'

@Component
export default class ViewBackofficePowerBi extends Vue {
  currentReport: PowerBiReportType = {
    id: '',
    nome: '',
    corporativo: false,
  } as PowerBiReportType

  get currentReportId() {
    return this.currentReport && this.currentReport.id
  }

  reportHospitalId = ''
  loadingPowerBi = false
  fullscreen = false
  teleport = true

  redesCurrentUser: Rede[] = []
  redeId = ''
  loadingRedes = false

  async toggle() {
    await fullscreen.toggle(this.$el.querySelector('.embed-wrapper'), {
      teleport: this.teleport,
      callback: (isFullscreen) => {},
    })
    this.fullscreen = fullscreen.isFullscreen
  }

  voltarParaAgendamento() {
    window.history.back()
  }

  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get getEmbeddedInfo() {
    return this.getBackofficeGlobalStore.embeddedInfo
  }

  set getEmbeddedInfo(value) {
    this.getBackofficeGlobalStore.setEmbeddedInfo(value)
  }

  get isCurrentReportCorporate(): boolean {
    return !!(this.currentReport && this.currentReport.corporativo)
  }

  get reportFieldsFlexDirectionRow(): boolean {
    if (this.isCurrentReportCorporate) {
      return this.redesCurrentUser.length <= 1
    }

    return this.getBackofficeGlobalStore.hospitalsCurrentUser.length === 1
  }

  async loadRedesCurrentUser() {
    if (this.redesCurrentUser.length) {
      return
    }

    try {
      this.loadingRedes = true

      const response = await Apis.Cadastro.CadastroApi.getRedesCurrentUser()

      if (!response.success) {
        EventBus.$emit('setSnackbar', getSnackbarMessage(response.message || 'Ocorreu um erro ao buscar as redes do usuário.', 'error'))
        return
      }

      this.redesCurrentUser = (response.data && response.data.redes) || []

      if (this.redesCurrentUser.length === 1) {
        this.redeId = this.redesCurrentUser[0].id
      }

      // FXIA-23215: nenhuma rede vinculada ao usuário — regra de negócio ainda não definida (TODO)
    } finally {
      this.loadingRedes = false
    }
  }

  async loadPowerBiEmbeddedInfo() {
    try {
      this.loadingPowerBi = true

      if (['', null, undefined].includes(this.currentReportId)) {
        this.loadingPowerBi = false
        return
      }

      if (this.getBackofficeGlobalStore.hospitalsCurrentUser.length === 1 && !this.isCurrentReportCorporate) {
        this.reportHospitalId = this.getBackofficeGlobalStore.hospitalsCurrentUser[0].id
      }

      const isCorporateReadyToEmbed = this.isCurrentReportCorporate && this.currentReportId && !!this.redeId
      const isHospitalarReadyToEmbed = !this.isCurrentReportCorporate && this.currentReportId && this.reportHospitalId

      if (isCorporateReadyToEmbed || isHospitalarReadyToEmbed) {
        await this.getBackofficeGlobalStore.getPowerBiEmbeddedInfo({ reportId: this.currentReportId, hospitalId: this.reportHospitalId, redeId: this.redeId })

        const powerbi = new pbi.service.Service(
          pbi.factories.hpmFactory,
          pbi.factories.wpmpFactory,
          pbi.factories.routerFactory,
        )

        const config = {
          type: 'report',
          tokenType: pbi.models.TokenType.Embed,
          accessToken: this.getBackofficeGlobalStore.embeddedInfo.token,
          embedUrl: this.getBackofficeGlobalStore.embeddedInfo.url,
          id: this.getBackofficeGlobalStore.embeddedInfo.id,
          settings: {
            layoutType: pbi.models.LayoutType.Master,
            backgroundType: pbi.models.BackgroundType.Transparent,
            panes: {
              filters: { expanded: false },
              pageNavigation: { visible: false },
            },
          },
          customLayout: {
            displayOption: pbi.models.DisplayOption.FitToPage,
          },
          permissions: pbi.models.Permissions.All,
        }

        const dashboardContainer = document.getElementById('report-container') as HTMLElement
        // Clear HTML before new append
        dashboardContainer.innerHTML = ''

        const dashboardWrapper = document.createElement('div')
        dashboardWrapper.className = 'embed-wrapper'
        dashboardWrapper.style.height = 'calc(0.5625 * 61vw)'
        dashboardContainer.appendChild(dashboardWrapper)

        const dashboard = powerbi.embed(dashboardWrapper, config)

        dashboard.off('loaded')
        dashboard.off('rendered')
        dashboard.on('error', () => dashboard.off('error'))
        dashboard.fullscreen()
      }
    } catch (error) {
      EventBus.$emit('setSnackbar', { show: true, text: 'Erro ao carregar relatório', icon: 'warning', color: '#C62828' })
    } finally {
      this.loadingPowerBi = false
    }
  }

  async reportInfoChange() {
    if (this.isCurrentReportCorporate) {
      await this.loadRedesCurrentUser()
    } else {
      this.redesCurrentUser = []
      this.redeId = ''
    }

    await this.loadPowerBiEmbeddedInfo()
  }

  async init() {
    await this.getBackofficeGlobalStore.getPowerBiReportTypes()
    await this.getBackofficeGlobalStore.getHospitalsCurrentUser()
  }

  async mounted() {
    await this.init()
  }
}
